module.exports = __webpack_public_path__ + "img/设备3web.67b05243.png";